<template>
  <div>
    <yjheader leftIcon=true
      rightIcon=false
      title="当前版本"></yjheader>
    <div class="homeBox">
      <div class="content">
        <!--
        <span>提示条款：</span>
        <p>欢迎使用本终端，请您阅读并遵守《软件产品使用许可协议》（以下简称“本协议“）。请您务必审慎阅读、充分理解各条款内容，特别是免除责任或限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。
        </p>

        <p class="paragraph">1.本终端禁止用于非法用途。包括国家法律及行业监管部门禁止的所有非法及违规行为。</p>
        <p class="paragraph">2.禁止使用非法手段破解、反编译以及逆向本软件系统。否则，软件开发方有权立刻终止合同并保留追究法律侵权责任的权利，期间所造成的损失由使用方自行承担 。</p>
        <p class="paragraph">3.如果由于手机网络不稳定，造成的客户损失，软件开发者不承担责任。</p>
        <p class="paragraph">4.若本移动终端出现交易或使用故障时，请及时使用电脑桌面终端继续进行交易，期间造成的损失，软件开发者不承担责任。</p>
        -->
        <p class="paragraph">{{'版本号(version): '+version2}}</p>

      </div>
    </div>
  </div>
</template>

<script>
import yjheader from "@/components/common/yjheader";
import { version } from "@/version.js";
export default {
  name: "user-protocol",
  data() {
    return {
      version2: version
    };
  },
  components: {
    yjheader
  }
};
</script>

<style scoped>
.homeBox {
  /*background: #161712;*/
  width: 100%;
  height: 100%;
  font-size: 0.26rem;
  font-family: Hiragino Sans GB, sans-serif;
}
.content {
  padding: 0.3rem 0.6rem;
}

.content span {
  font-size: 0.36rem;
  line-height: 1rem;
}
.paragraph {
  margin-top: 0.6rem;
}
.section_text {
  margin-top: 0.08rem;
}
.special_text {
  font-weight: bold;
  font-style: italic;
  text-decoration: underline;
}
span {
  font-weight: bold;
  line-height: 0.5rem;
}
p {
  line-height: 0.5rem;
  color: #fff;
  font-size: 0.26rem;
}
.version {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/yj/userProtocol.vue